import React, { useEffect } from 'react';

const DifficultySelectionScreen = ({ selectedPuzzle, setSelectedDifficulty, setCurrentScreen }) => {
  useEffect(() => {
    if (!selectedPuzzle) {
      setCurrentScreen('selectPuzzle');
    }
  }, [selectedPuzzle, setCurrentScreen]);

  if (!selectedPuzzle) return null;

  const handleSelect = (level) => {
    setSelectedDifficulty(level);
    setTimeout(() => {
      setCurrentScreen('game');
    }, 50);
  };

  return (
    <div className="flex flex-col items-center justify-center h-full p-4 text-center">
      <div className="bg-white p-8 rounded-xl shadow-2xl max-w-lg w-full border-4 border-orange-500">
        <h2 className="text-3xl font-extrabold mb-6 text-pink-600">Choose Difficulty</h2>
        <p className="text-gray-700 text-lg mb-8">
          How hard do you want to go with <span className="text-orange-600 font-bold">{selectedPuzzle.name}</span>?
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full mb-6">
          <button
            onClick={() => handleSelect('easy')}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition duration-300"
          >
            Easy (3×3)
          </button>
          <button
            onClick={() => handleSelect('medium')}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-6 rounded-lg transition duration-300"
          >
            Medium (4×4)
          </button>
          <button
            onClick={() => handleSelect('hard')}
            className="bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-6 rounded-lg transition duration-300"
          >
            Hard (5×5)
          </button>
        </div>

        <button
          onClick={() => setCurrentScreen('selectPuzzle')}
          className="mt-4 bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-lg hover:bg-gray-400 transition"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default DifficultySelectionScreen;
